import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const WarningIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <circle cx="12" cy="12" r="12" fill="#E96716" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9105 6.28579C12.5136 5.5714 11.4862 5.5714 11.0893 6.28579L5.58848 16.1872C5.20276 16.8815 5.70481 17.7348 6.49906 17.7348H17.5007C18.2949 17.7348 18.797 16.8815 18.4113 16.1872L12.9105 6.28579ZM9.9966 5.67873C10.8697 4.10709 13.13 4.10709 14.0032 5.67874L19.504 15.5802C20.3526 17.1077 19.248 18.9848 17.5007 18.9848H6.49906C4.7517 18.9848 3.6472 17.1077 4.49579 15.5802L9.9966 5.67873ZM11.9999 8.77652C12.3451 8.77652 12.6249 9.05634 12.6249 9.40152V13.5682C12.6249 13.9134 12.3451 14.1932 11.9999 14.1932C11.6547 14.1932 11.3749 13.9134 11.3749 13.5682V9.40152C11.3749 9.05634 11.6547 8.77652 11.9999 8.77652ZM11.9999 16.0682C12.3451 16.0682 12.6249 15.7884 12.6249 15.4432C12.6249 15.098 12.3451 14.8182 11.9999 14.8182C11.6547 14.8182 11.3749 15.098 11.3749 15.4432C11.3749 15.7884 11.6547 16.0682 11.9999 16.0682Z"
          fill="white"
        />
      </svg>
    );
  }
);

export default WarningIcon;
